window.addEventListener("DOMContentLoaded", function () {
  function moveContent() {
    if (!window.subscription_recharge_container) {
      console.log("Error: subscription_recharge_container is empty or null.");
      observer.disconnect();
      return;
    }

    const contentDiv = document.querySelector(
      window.subscription_recharge_container
    );
    const destinationDiv = document.getElementById("subscription-widget");

    if (contentDiv && destinationDiv) {
      destinationDiv.appendChild(contentDiv);
      observer.disconnect();
    }
  }

  const observer = new MutationObserver(function () {
    moveContent();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
